module.exports = __webpack_public_path__ + "static/img/home-header.011f037.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/home-header.png
// module id = 9a4Z
// module chunks = 0